import { createSlice } from '@reduxjs/toolkit'

const initialStateValue = {
  countryCodeArr:[]
    

}

export const countryArrSlice = createSlice({
  name: 'country',
  initialState: initialStateValue,
  reducers: {
   setCountryArray:(state,action)=>{
    const countryData = action.payload
   
    state.countryCodeArr = countryData
   }
  
   

  },
})

export const {setCountryArray} = countryArrSlice.actions

export default countryArrSlice.reducer
